import { createTheme } from "@mui/material/styles";
import {
  grey50,
  white,
  black,
  black100,
  black200,
  grey1000,
  primaryBlue,
  dividerGrey,
  grey200,
  black300,
  grey300,
  statusRed,
  backgroundRed,
  tableGreenText,
  backgroundGreen,
} from "../../config/colors";

export const theme = createTheme({
  palette: {
    Transparent: {
      main: "transparent",
    },
    Blue: {
      main: primaryBlue,
      // dark: primaryBlue,
      contrastText: white,
    },
    Black: {
      main: black,
      dark: black100,
      light: grey50,
    },
    White: {
      main: white,
      dark: grey1000,
    },
    // Smoke: {
    //   main: grey100,
    //   light: grey50,
    //   dark: grey200,
    // },
    // LightGrey: {
    //   main: grey400,
    //   light: grey300,
    //   dark: grey500,
    // },
    Grey: {
      main: grey50,
      // dark: grey600,
      // light: grey900,
    },
  },
  typography: {
    h2: {
      fontWeight: 600,
      fontSize: "2.6074vh",
      lineHeight: "3.33vh",
      color: black100,
      fontFamily: "Poppins",
    },
    h3: {
      fontWeight: 600,
      fontSize: "2.167vh",
      lineHeight: "2.9074vh",
      color: black200,
      textAlign: "left",
      fontFamily: "Poppins",
    },
    smallh3: {
      fontWeight: 600,
      fontSize: "1.667vh",
      lineHeight: "2.22vh",
      color: black200,
      textAlign: "left",
      fontFamily: "Poppins",
    },
    h4: {
      fontWeight: 400,
      fontSize: "1.867vh",
      lineHeight: "2.42vh",
      color: grey50,
      fontFamily: "Poppins",
    },
    h5: {
      fontWeight: 400,
      fontSize: "1.75vh",
      color: grey1000,
      textAlign: "left",
      letterSpacing: 0.2,
      fontFamily: "Poppins",
    },
    tableText: {
      fontWeight: 400,
      fontSize: "2.04vh",
      lineHeight: "2.71vh",
      // color: black200,
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    smalltableText: {
      fontWeight: 400,
      fontSize: "1.84vh",
      lineHeight: "2.51vh",
      // color: black200,
      fontFamily: "Poppins",
    },
    body1: {
      fontWeight: 300,
      fontSize: "1.94vh",
      lineHeight: "2.71vh",
      fontFamily: "Poppins",
      color: black200,
      // lineHeight: "2.16vh",
      // color: grey800,
    },
    caption: {
      fontSize: "1.49vh",
      fontFamily: "Poppins",
      color: statusRed,
    },
    filterAppliedText: {
      fontSize: "1.67vh",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: "2.0056vh",
      color: black,
    },
    durationText: {
      fontSize: "1.57vh",
      fontFamily: "Poppins",
      fontWeight: 500,
      lineHeight: "2.0056vh",
      color: black300,
      textAlign: "right",
    },
    cardHeader: {
      fontWeight: 500,
      fontSize: "1.78vh",
      lineHeight: "3.02vh",
      color: black,
      fontFamily: "Poppins",
    },
    cardText: {
      fontWeight: 600,
      fontSize: "2.42vh",
      lineHeight: "3.53vh",
      color: black100,
      fontFamily: "Poppins",
    },
    positiveText: {
      gap: "3px",
      // width: "fit-content",
      color: tableGreenText,
      backgroundColor: backgroundGreen,
      borderColor: backgroundGreen,
      display: "flex",
      alignItems: "center",
      padding: "5px 0px",
      margin: "0px 10px",
      borderRadius: "4px",
      justifyContent: "center",
    },
    negativeText: {
      gap: "3px",
      // width: "fit-content",
      color: statusRed,
      backgroundColor: backgroundRed,
      borderColor: backgroundRed,
      display: "flex",
      alignItems: "center",
      padding: "5px 0px",
      margin: "0px 10px",
      borderRadius: "4px",
      justifyContent: "center",
    },
    blueHeadText: {
      fontWeight: 600,
      color: primaryBlue,
      fontSize: "3.1074vh",
      lineHeight: "3.83vh",
      textAlign: "left",
    },
    cardTopText: {
      fontWeight: 500,
      fontSize: "1.98vh",
      lineHeight: "3.02vh",
      color: primaryBlue,
      fontFamily: "Poppins",
      position: "absolute",
      right: "50px",
    },
    disabledText: {
      opacity: 0.5,
      fontWeight: 400,
      fontSize: "1.94vh",
      lineHeight: "2.71vh",
      // color: black200,
      fontFamily: "Poppins",
    },
    homeHeaderText: {
      fontWeight: 600,
      fontSize: "2.167vh",
      lineHeight: "2.9074vh",
      color: white,
      textAlign: "left",
      fontFamily: "Poppins",
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: dividerGrey,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "0.7407vh 1.4815vw",
          minWidth: "fit-content",
          textTransform: "none",
          fontSize: "1.67vh",
          lineHeight: "2.0519vh",
          borderRadius: "6px",
          boxShadow: "none",
          fontWeight: 500,
          borderWidth: "2px",
          borderColor: primaryBlue,
          color: primaryBlue,
          "&:hover": {
            borderWidth: "2px",
            borderColor: primaryBlue,
            color: primaryBlue,
          },
          // height: "2.777vh",
          // "&.MuiButton-sizeSmall": {
          //   fontSize: "1.29vh",
          //   lineHeight: "2.16vh",
          //   padding: "0vh 0.52vw",
          //   height: "2.22vh",
          //   minWidth: "fit-content",
          //   display: "flex",
          //   alignItems: "center",
          //   fontWeight: "normal",
          // },
          "&.MuiButton-sizeLarge": {
            fontSize: "2.08vh",
            padding: "1.11vh 0.83vw",
            height: "4.903vh",
            fontWeight: 500,
            backgroundColor: primaryBlue,
            color: white,

            "&.Mui-disabled": {
              backgroundColor: grey200,
              cursor: "not-allowed",
            },
          },
          // "&.size-extra-large": {
          //   height: "4.074vh",
          //   fontSize: "1.666vh",
          //   lineHeight: "2.16vh",
          //   fontWeight: 500,
          // },
          "&.MuiButton-outlinedSizeModerate": {
            borderColor: grey200,
            backgroundColor: grey50,
            color: black300,
          },
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          backgroundColor: grey50,
          borderColor: grey200,
          borderRadius: "4px",
          ".MuiToggleButton-root": {
            borderWidth: "2px",
            color: black,
            lineHeight: 1.25,
            fontSize: "1.40vh",
            fontFamily: "Poppins",
            padding: "10px",
          },
          ".Mui-selected": {
            backgroundColor: `${primaryBlue} !important`,
            color: `${white} !important`,
            "&:hover": {
              color: black,
            },
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          background: grey50,
          ".MuiCheckbox": {
            color: primaryBlue,
            "&.checked": {
              color: primaryBlue,
            },
          },
          ".MuiAutocomplete-endAdornment": {
            top: "calc(50% - 9px)",
          },
          ".MuiOutlinedInput-notchedOutline": {
            border: `2px solid ${grey200}`,
          },
          ".MuiOutlinedInput-root": {
            padding: "2px",
            height: "35px",
            overflow: "hidden",
          },
          ".MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
            paddingTop: "2px",
            paddingBottom: "2px",
            paddingLeft: "4px",
          },
        },
        option: {
          fontSize: "1.8vh",
          fontFamily: "Poppins",
          fontWeight: 400,
          lineHeight: 1.2,
        },
        listbox: {
          maxHeight: "35vh",
          background: white,
        },
        noOptions: {
          background: white,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: "1.4vh",
          height: "26px",
          ".MuiChip-deleteIcon": {
            fontSize: "18px",
          },
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          ".MuiPagination-ul": {
            justifyContent: "end",
            padding: "1.25vh",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "Poppins !important",
          fontSize: "1.65vh",
          // fontWeight: 300,
          fontWeight: 400, //changed acc to bug
          color: black,
          backgroundColor: grey50,
          height: "5.5vh",
          borderRadius: "0.56vh",
          padding: "auto",

          // "&.MuiInputBase-multiline": {
          //   height: "10vh",
          //   padding: "0 1.11vh",
          // },
          "& fieldset": {
            // borderColor: grey700,
            borderColor: black, //changed acc to bug
          },
          "&.Mui-focused fieldset": {
            borderWidth: "0.092vh !important",
          },
          "&.Mui-disabled": {
            backgroundColor: grey200,
          },
          "&.MuiInputBase-sizeSmall": {
            height: "6vh",
            paddingLeft: "0.52vw",
            paddingRight: "0.52vw",
            borderRadius: "0.37vh",
            // maxWidth:"50vw",
            "& input": {
              padding: 0,
            },
            "&.page-input": {
              paddingLeft: "0.1vw",
              paddingRight: "0.1vw",
              "& input": {
                textAlign: "center",
              },
            },
            // uncomment if some error occurs
            // "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
            //   {
            //     "-webkit-appearance": "none",
            //     margin: 0,
            //   },
            // '& input[type="number"]': {
            //   "-moz-appearance": "textfield",
            // },
          },
        },
        input: {
          paddingTop: "0vh",
          paddingBottom: "0vh",
          "&.Mui-disabled": {
            WebkitTextFillColor: `${black} !important`,
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: primaryBlue,
        },
        valueLabel: {
          fontSize: "1.7vh",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "&.MuiDialogTitle-root": {
            backgroundColor: primaryBlue,
            color: white,
            fontSize: "2vh",
            fontFamily: "Poppins",
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr 1fr",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          width: "23vw",
        },
      },
    },
    // MuiTableRow: {
    //   styleOverrides: {
    //     root: {
    //       "&:hover": {
    //         color: black,
    //       },
    //     }
    //   }
    // }
    // MuiToggleButton: {
    //   styleOverrides: {
    //     root: {
    //       ".Mui-selected": {
    //         backgroundColor: primaryBlue,
    //         color: white,
    //       },
    //     },
    //   },
    // },
    //   MuiBox: {
    //     styleOverrides: {
    //       root: {
    //         "&>.size-moderate": {
    //           "&>.MuiOutlinedInput-root": {
    //             height: "3.703vh",
    //             backgroundColor: "red",
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiPaper: {
    //     styleOverrides: {
    //       root: {
    //         backgroundColor: grey100,
    //         border: "none",
    //         borderRadius: "0vh",
    //         boxShadow: "none",
    //         padding: "2.23vh 1.25vw",
    //       },
    //     },
    //   },
    //   MuiPopover: {
    //     styleOverrides: {
    //       paper: {
    //         backgroundColor: grey50,
    //         borderRadius: "0.56vh",
    //         padding: "0vh 0vw",
    //         minWidth: "11.458vw",
    //         "& .MuiMenuItem-root": {
    //           whiteSpace: "initial",
    //           wordBreak: "break-word",
    //         },
    //       },
    //       root: {
    //         "&.simple-popover": {
    //           "& .MuiPopover-paper": {
    //             padding: "0.926vh 1.0416vw",
    //             borderRadius: "0.37vh",
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiPickersPopper: {
    //     styleOverrides: {
    //       paper: {
    //         backgroundColor: grey50,
    //         padding: "0vh 0vw",
    //       },
    //       root: {
    //         "& .Mui-selected": {
    //           backgroundColor: "#171C8F !important",
    //         },
    //         "& .MuiDateCalendar-root": {
    //           width: "31vh",
    //           height: "31vh",

    //           "& .MuiPickersCalendarHeader-root": {
    //             marginTop: "1.5vh",
    //             marginBottom: "1vh",
    //             paddingLeft: "1.48vh",
    //             paddingRight: "0.5vh",
    //             maxHeight: "2.5vh",
    //             minHeight: "2.5vh",

    //             "& .MuiPickersCalendarHeader-label": {
    //               marginRight: 0,
    //             },
    //           },

    //           "& .MuiDayCalendar-header": {
    //             "& .MuiDayCalendar-weekDayLabel": {
    //               width: "100%",
    //               fontSize: "1.22vh",
    //               height: "1.5vh",
    //             },
    //           },

    //           "& .MuiPickersSlideTransition-root": {
    //             minHeight: 0,

    //             "& .MuiDayCalendar-weekContainer": {
    //               "& .MuiPickersDay-root": {
    //                 fontSize: "1.22vh",
    //                 width: "3.85vh",
    //                 height: "3.85vh",

    //                 "&.MuiPickersDay-root .Mui-selected": {
    //                   backgroundColor: marutiBlue700,
    //                 },
    //               },
    //             },
    //           },

    //           "& .MuiYearCalendar-root": {
    //             width: "31vh",
    //             height: "28vh",

    //             "& .MuiPickersYear-yearButton": {
    //               fontSize: "1.22vh",
    //               width: "3vw",
    //               height: "4vh",
    //             },
    //           },

    //           "& .MuiMonthCalendar-root": {
    //             width: "15vw",
    //             "& .MuiPickersMonth-monthButton": {
    //               height: "3vh",
    //               width: "3vw"
    //             }
    //           }
    //         },

    //         "& .MuiButtonBase-root": {
    //           fontSize: "1.22vh",
    //         },
    //         "& .MuiPickersCalendarHeader-labelContainer": {
    //           fontSize: "1.22vh",
    //         },
    //       },
    //     },
    //   },
    //   MuiMenuItem: {
    //     styleOverrides: {
    //       root: {
    //         "&.Mui-disabled": {
    //           opacity: 1,
    //           "&:hover": {
    //             backgroundColor: grey50,
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiCheckbox: {
    //     styleOverrides: {
    //       root: {
    //         color: "#171C8F",
    //         "&$checked": {
    //           color: "#171C8F",
    //         },
    //       },
    //     },
    //   },
    //   MuiOutlinedInput: {
    //     styleOverrides: {
    //       root: {
    //         fontFamily: "Roboto !important",
    //         fontSize: "1.3vh",
    //         // fontWeight: 300,
    //         fontWeight: 400, //changed acc to bug
    //         color: grey800,
    //         backgroundColor: grey50,
    //         height: "3.15vh",
    //         borderRadius: "0.56vh",
    //         padding: "auto",

    //         "&.MuiInputBase-multiline": {
    //           height: "10vh",
    //           padding: "0 1.11vh",
    //         },
    //         "& fieldset": {
    //           // borderColor: grey700,
    //           borderColor: grey800, //changed acc to bug
    //         },
    //         "&.Mui-focused fieldset": {
    //           borderWidth: "0.092vh !important",
    //         },
    //         "&.Mui-disabled": {
    //           backgroundColor: grey200,
    //         },
    //         "&.MuiInputBase-sizeSmall": {
    //           height: "2.22vh",
    //           paddingLeft: "0.52vw",
    //           paddingRight: "0.52vw",
    //           borderRadius: "0.37vh",
    //           // maxWidth:"50vw",
    //           "& input": {
    //             padding: 0,
    //           },
    //           "&.page-input": {
    //             paddingLeft: "0.1vw",
    //             paddingRight: "0.1vw",
    //             "& input": {
    //               textAlign: "center",
    //             },
    //           },
    //           // uncomment if some error occurs
    //           // "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
    //           //   {
    //           //     "-webkit-appearance": "none",
    //           //     margin: 0,
    //           //   },
    //           // '& input[type="number"]': {
    //           //   "-moz-appearance": "textfield",
    //           // },
    //         },
    //       },
    //       input: {
    //         paddingTop: "0vh",
    //         paddingBottom: "0vh",
    //         "&.Mui-disabled": {
    //           WebkitTextFillColor: `${grey800} !important`,
    //         },
    //       },
    //     },
    //   },
    //   MuiTableContainer: {
    //     styleOverrides: {
    //       root: {
    //         borderRadius: "0vh",
    //         boxShadow: "none",
    //         border: `1px solid ${grey700}`,
    //         "&.full-height": {
    //           maxHeight: "79vh",
    //         },
    //         "&.noborder-table": {
    //           border: "none",
    //           height: "45vh",

    //           MuiTableCell: {
    //             styleOverrides: {
    //               root: {
    //                 borderRight: "none",
    //               },
    //             },
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiTable: {
    //     styleOverrides: {
    //       root: {
    //         borderCollapse: "inherit",

    //         "&.competition-table": {
    //           "& .MuiTableCell-root": {
    //             fontSize: "1.57vh !important",
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiTableRow: {
    //     styleOverrides: {
    //       root: {
    //         backgroundColor: grey100,
    //         "&.selected": {
    //           position: "sticky",
    //           top: "5vh",
    //           zIndex: 4,
    //           backgroundColor: compBlue300,

    //           // "& .MuiTableCell-root": {
    //           //   color: "#ffffff",
    //           // },
    //         },
    //         "&:last-of-type": {
    //           "& .MuiTableCell-root": {
    //             borderBottom: "none",
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiTableCell: {
    //     styleOverrides: {
    //       root: {
    //         padding: "0.93vh 0.52vw",
    //         borderColor: "transparent",
    //         borderRight: `1px solid ${grey700}`,
    //         borderBottom: `1px solid ${grey700}`,
    //         borderCollapse: "collapse",
    //         "&:last-of-type": {
    //           borderRight: "none",
    //           // borderBottom:"none",
    //         },
    //         "&.category": {
    //           fontWeight: 600,
    //           borderRight: `none`,
    //           borderTop: `1px solid ${grey700}`,
    //           borderBottom: `1px solid ${grey700}`,
    //         },
    //         "&.trans-table-cell": {
    //           borderRight: `none`,
    //           borderBottom: "none",
    //         },
    //       },

    //       head: {
    //         position: "sticky",
    //         height: "5vh",
    //         fontWeight: 500,
    //         fontSize: "1.48vh",
    //         lineHeight: "2.16vh",
    //         color: white,
    //         backgroundColor: primaryBlue,
    //         borderRight: `none`,
    //         top: "0",

    //         "&.trans-table-header": {
    //           backgroundColor: "inherit",
    //           color: primaryBlue,
    //         },
    //       },
    //       body: {
    //         fontWeight: "normal",
    //         fontSize: "1.48vh",
    //         lineHeight: "2.16vh",
    //         color: grey800,
    //       },
    //       // footer: {
    //       //   padding: "0rem !important",
    //       //   "&:hover": {
    //       //     backgroundColor: `${MarutiWhite} !important`,
    //       //   },
    //       // },
    //     },
    //   },
    //   MuiButton: {
    //     styleOverrides: {
    //       root: {
    //         padding: "0.277vh 0.729vw",
    //         minWidth: "fit-content",
    //         textTransform: "capitalize",
    //         fontSize: "1.29vh",
    //         lineHeight: "2.16vh",
    //         borderRadius: "0.37vh",
    //         boxShadow: "none",
    //         fontWeight: 500,
    //         // height: "2.777vh",
    //         "&.MuiButton-sizeSmall": {
    //           fontSize: "1.29vh",
    //           lineHeight: "2.16vh",
    //           padding: "0vh 0.52vw",
    //           height: "2.22vh",
    //           minWidth: "fit-content",
    //           display: "flex",
    //           alignItems: "center",
    //           fontWeight: "normal",
    //         },
    //         "&.MuiButton-sizeLarge": {
    //           fontSize: "1.48vh",
    //           lineHeight: "1.48vh",
    //           padding: "1.11vh 0.83vw",
    //           height: "3.703vh",
    //           fontWeight: 500,
    //         },
    //         "&.size-extra-large": {
    //           height: "4.074vh",
    //           fontSize: "1.666vh",
    //           lineHeight: "2.16vh",
    //           fontWeight: 500,
    //         },
    //         "&.size-moderate": {
    //           height: "3.703vh",
    //           padding: "1.48vh 1.66vw",
    //           fontSize: "1.48vh",
    //           fontWeight: 500,
    //         },
    //       },
    //     },
    //   },
    //   MuiAutocomplete: {
    //     styleOverrides: {
    //       root: {
    //         "& .MuiInputBase-root": {
    //           height: "3.703vh",
    //         },
    //       },
    //       inputRoot: {
    //         flexWrap: "inherit",
    //         minWidth: "2.6vw !important",
    //         paddingRight: "2.6vw!important",
    //       },
    //       endAdornment: {
    //         paddingTop: "0.8vh",
    //       },
    //       paper: {
    //         backgroundColor: grey50,
    //         border: "none",
    //         borderRadius: "0.56vh",
    //         boxShadow: "none",
    //         padding: "0vh 0vw",
    //         minWidth: "13.1vw",
    //       },
    //       option: {
    //         fontWeight: 300,
    //         fontSize: "1.3vh",
    //         lineHeight: "1.3vh",
    //         color: grey800,
    //         padding: "auto 1.3vw",
    //       },
    //       listbox: {
    //         padding: "0vh 0vw",
    //         maxHeight: "30vh",
    //         overflowY: "auto",
    //       },
    //       groupLabel: {
    //         backgroundColor: grey50,
    //         padding: "1.1vh 1.2vw 0vh 1.2vw",
    //         position: "static",
    //       },
    //     },
    //   },
    //   MuiTabs: {
    //     styleOverrides: {
    //       root: {
    //         padding: "0vh 0vw 0vh 0.29vw",
    //         minHeight: "fit-content !important",
    //       },
    //       indicator: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //   },
    //   MuiTabPanel: {
    //     styleOverrides: {
    //       root: {
    //         backgroundColor: grey50,
    //         minHeight: "48vh",
    //         borderRadius: "0.74vh",
    //         padding: "2.59vh 1.25vw",
    //       },
    //     },
    //   },
    //   MuiTab: {
    //     styleOverrides: {
    //       textColorPrimary: {
    //         fontWeight: "normal",
    //         fontSize: "1.48vh",
    //         lineHeight: "2.16vh",
    //         color: grey800,
    //         textTransform: "inherit",
    //         //   minWidth: "fit-content !important",
    //         //   width: "fit-content !important",
    //         minHeight: "4.81vh",
    //       },
    //       root: {
    //         "&.MuiButtonBase-root": {
    //           height: "4.81vh",
    //           borderRadius: "0.55vh 0.55vh 0vh 0vh",
    //           border: `1px solid ${grey400}`,
    //           borderBottom: "none",
    //           backgroundColor: grey50,
    //         },
    //         "&.Mui-selected": {
    //           borderColor: primaryBlue,
    //           fontWeight: "600 !important",
    //           color: white,
    //           backgroundColor: primaryBlue,
    //           "& .MuiTouchRipple-child": {
    //             backgroundColor: `${primaryBlue} !important`,
    //           },
    //         },
    //       },
    //     },
    //   },
    //   MuiCheckbox: {
    //     styleOverrides: {
    //       root: {
    //         padding: "0vh 0.468vw 0vh 0vw",
    //       },
    //     },
    //   },
    //   MuiList: {
    //     styleOverrides: {
    //       root: {
    //         maxHeight: "50vh",
    //       },
    //     },
    //   },
    //   MuiInputAdornment: {
    //     styleOverrides: {
    //       positionStart: {
    //         marginRight: "0.2083vw",
    //         marginTop: "0.2vh",
    //       },
    //       positionEnd: {
    //         marginTop: "0.2vh",
    //       },
    //     },
    //   },
    //   MuiRadio: {
    //     styleOverrides: {
    //       root: {
    //         padding: "0.4630vh",
    //         paddingLeft: "1.6vh"
    //       },
    //     },
    //   },
  },
});
